import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../app.service';
import { EmailMarketingService } from '../email-marketing.service';
import { Constants } from '../../../shared/utils/constants';
import { EmailCampaignProps } from '../../email-history/email-history.model';
import { map } from 'rxjs/operators';
import { EmailHistoryService } from '../../email-history/email-history.service';
import { NgModel } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'fx-option-send',
  templateUrl: './option-send.component.html',
  styleUrls: ['./option-send.component.sass'],
})
export class OptionSendComponent implements OnInit {
  @ViewChild('datePicker') datePicker: NgModel;
  data: any = {
    content: '',
    keyword: '',
    sub: '',
    active_user: false,
    active_ib: false,
    without_deposit: false,
    country: 'all',
    emailType: 'noreply',
  };
  campaignName = '';
  emailTypes = Constants.EMAIL_TYPES;
  listPreview = [];
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  isCondition = false;
  isDisableWithoutDeposit = false;
  schedulerDate = '';
  campaignCreatedList: EmailCampaignProps[] = []
  selectedCampaign: any;
  minDate = new Date();
  maxContentLength = 5000;
  constructor(
    private appService: AppService,
    private service: EmailMarketingService,
    private readonly mailService: EmailHistoryService,
    private readonly elr: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    this.getCampaignList();
  }

  getCampaignList() {
    this.mailService.getCampaignHistory().pipe(
      map(e => e.data.campaigns),
    ).subscribe({
      next: (data) => {
        this.campaignCreatedList = data;
      }
    });
  }

  searchEmail(event): void {
    if (event.keyCode === 13 || event === 'click') {
      this.pageInfo.pageIndex = 1;
      this.postPreviewEmail();
    }
  }
  postPreviewEmail(): void {
    if (this.isCondition) {
      const indexUser = +$('input[name=accountType]:checked').val();
      const indexCountry = +$('input[name=countryType]:checked').val();
      this.data.active_user = indexUser === 1;
      this.data.active_ib = indexUser === 2;
      this.data.without_deposit =
        $('input[name=withdrawDeposit]:checked').val() !== undefined;
      this.data.country =
        indexCountry === 2 ? 'only_jp' : indexCountry === 3 ? 'not_jp' : 'all';
    }
    const body = {
      country: this.data.country,
      isDisableWithoutDeposit: this.isDisableWithoutDeposit,
      accounts: {
        active_user: this.data.active_user,
        active_ib: this.data.active_ib,
        without_deposit: this.data.without_deposit,
      },
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
      q: this.data.keyword.trim(),
      type: 'condition'
    };
    this.service.optionPreview(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.listPreview = res.data;
        this.pageInfo.totalRecord = res.paging.total;
        if (this.listPreview.length <= 0) {
          this.appService.showWarning('Email sending empty.');
        }
      }
    });
  }

  postSendEmail(): void {
    this.convertWysOtherText();
    if (this.data.content?.length <= 0 || !this.data.content || this.data.content === '<div><br></div>') {
      this.appService.showError('Please enter content.');
      return;
    }
    if(this.data.content?.length > this.maxContentLength) {
      return this.appService.showError(`Please enter content less than ${this.maxContentLength} symbols. Currently is ${this.data.content.length}`);
    }
    if (!this.data.sub) {
      this.appService.showError('Please enter subject.');
      return;
    }
    const indexUser = +$('input[name=accountType]:checked').val();
    this.data.without_deposit = $('input[name=withdrawDeposit]:checked').val() !== undefined;
    const indexCountry = +$('input[name=countryType]:checked').val();
    this.data.country = indexCountry === 2 ? 'only_jp' : indexCountry === 3 ? 'not_jp' : 'all';
    this.data.active_user = indexUser === 1;
    this.data.active_ib = indexUser === 2;
    if(this.campaignName.length === 0) {
      return this.appService.showError('Campaign name is required.');
    }
    const body = {
      country: this.data.country,
      name: this.campaignName,
      accounts: {
        active_user: this.data.active_user,
        active_ib: this.data.active_ib,
        without_deposit: this.data.without_deposit,
      },
      type_mail: this.data.emailType,
      text: this.data.content,
      subject: this.data.sub,
      type: 'condition',
      campaign_name: this.campaignName,
      ...((this.schedulerDate.length !== 0) && { time: new Date(this.schedulerDate).getTime() }),
    };
    this.service.optionSend(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Sending mail success');
        this.data.sub = '';
        this.data.content = '';
        this.campaignName = '';
        this.listPreview = [];
        this.selectedCampaign = null;
        this.schedulerDate = null;
        this.datePicker.control.reset();
        $('div.nicEdit-main').html('');
        this.getCampaignList();
      }
    });
  }

  onChangeAcc(): void {
    const valueAccType = +$('input[name=accountType]:checked').val();
    this.isDisableWithoutDeposit = valueAccType === 2;
  }
  convertWysOtherText(): void {
    if ($('#fill-content-other').text()) {
      this.data.content = `<div>${$('#fill-content-other').text()}</div>`;
    }
  }
  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.isCondition = false;
    this.postPreviewEmail();
  }
}
